import script from "./Aside.vue?vue&type=script&setup=true&lang=js"
export * from "./Aside.vue?vue&type=script&setup=true&lang=js"

import "./Aside.vue?vue&type=style&index=0&id=746aad1a&lang=css"

const __exports__ = script;

export default __exports__